import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderShared: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-shared"><path d="M13.25 19.25H21.25V6.75H12L10 3.75H2.75V7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 12.5C7.75 13.4665 6.9665 14.25 6 14.25C5.0335 14.25 4.25 13.4665 4.25 12.5C4.25 11.5335 5.0335 10.75 6 10.75C6.9665 10.75 7.75 11.5335 7.75 12.5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M6 16.75C8.09121 16.75 9.82829 18.2606 10.1826 20.25H1.81738C2.17171 18.2606 3.90879 16.75 6 16.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFolderShared;
